import { cn } from '@/utils/cn';
import { PROGRESS_ITEMS, SEPARATOR_SELECTOR_CLASSNAME } from '../constant';
import { summerTitleConvertorBasedOnComponentName } from '../utils';
interface Props {
  title: string;
}
const SectionTitleDivider = ({
  title
}: Props) => {
  const convertedTitle = summerTitleConvertorBasedOnComponentName(title);
  const color = PROGRESS_ITEMS.find(item => item.title === convertedTitle)?.color ?? '#D4D4D4';
  return <div className={cn(SEPARATOR_SELECTOR_CLASSNAME, 'homepage-container flex items-center gap-2')} data-sentry-component="SectionTitleDivider" data-sentry-source-file="index.tsx">
            <span className='h-px w-4 shrink-0 lg:w-32' style={{
      backgroundColor: color
    }} aria-hidden='true' />
            <h2 className='shrink-0 text-caption-12 font-medium lg:text-body-16'>{convertedTitle}</h2>
            <span className='h-px flex-1' style={{
      backgroundColor: color
    }} aria-hidden='true' />
        </div>;
};
export default SectionTitleDivider;